export const defaultInputValidationPaneTitleStyles = {
  color: "#323130",
  fontFamily: "'Segoe UI', Arial, sans-serif",
  fontSize: "18px",
  fontWeight: "500",
  marginBottom: "5px"
};